import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { HomeHero } from "../components/home/HomeHero";
import { StatsBand, PressBand } from "../components/home/StatsAndPress";
import { StatementExample } from "../components/home/StatementExample";
import { MethodSection, CasesSection } from "../components/home/MethodAndCases";
import { LatestArticles } from "../components/home/LatestArticles";
import { FinalCta } from "../components/FinalCta";

export default function Home() {
    useDocumentMeta({
        title: "FOD by DMB Partners — Simulez vos économies bancaires en 30 secondes",
        description:
            "Audit et optimisation des frais bancaires des PME et ETI. Simulation gratuite en 30 secondes, mission menée en trois semaines en moyenne.",
        canonical: "https://www.fodbydmb.com/",
    });

    return (
        <div data-testid="home-page">
            <HomeHero />
            <StatsBand />
            <PressBand />
            <StatementExample />
            <MethodSection />
            <CasesSection />
            <LatestArticles />
            <FinalCta />
        </div>
    );
}
